import type DropdownItemConfig from '../../../types/models/layout/DropdownItemConfig'

export default class DropdownConfig{
    items:DropdownItemConfig[]
    handleClick(){alert("未实现")}
}